import { Box } from "@mui/material";
import DatePicker, { DateObject } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

const RequestForm = styled(Box)`
    .rmdp-input {
        background-color: #fcfffd;
        text-align: center;
        height: 3.25rem;
        width: 22ch;
        font-size: 1rem;
        border-radius: 0;
        border: none;
        border-right: none;
        :hover {
            cursor: pointer;
            filter: brightness(95%);
        }
    }

    .rmdp-calendar {
        margin: 3px;
    }

    .rmdp-week-day {
        color: #3b3b3b;
    }

    .rmdp-day.rmdp-today > span {
        background-color: #b6d9fd;
        color: black;
        // border: 1px solid #3b3b3b;
    }

    .pickerinput {
        background-color: #fcfffd;
    }
`;
interface AdminNationalHolidayPickerParams {
    setDates: React.Dispatch<React.SetStateAction<string[]>>;
    setReset: React.Dispatch<React.SetStateAction<boolean>>;
    reset: boolean;
}

const AdminNationalHolidayPicker = ({
    setDates,
    setReset,
    reset,
}: AdminNationalHolidayPickerParams) => {
    const today = dayjs(new Date().toString()).format("YYYY-MM-DD");
    const [value, setValue] = useState<DateObject[]>([new DateObject(today)]);

    useEffect(() => {
        if (value) {
            setDates(value.toString().split(","));
        }
    }, [value]);

    useEffect(() => {
        if (reset) {
            setValue([new DateObject(today)]);
            setReset(false);
        }
    }, [reset]);

    return (
        <RequestForm>
            <DatePicker
                className="pickerinput"
                value={value}
                onChange={(dates: DateObject[]) => setValue(dates)}
                format="YYYY-MM-DD"
                multiple
                plugins={[<DatePanel />]}
            />
        </RequestForm>
    );
};

export default AdminNationalHolidayPicker;
